import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/business/technologies/"
    exact
    path="/business/technologies/:feature"
    component={AsyncPage}
  />,
];
